module.exports = __webpack_public_path__ + "static/media/iss.5b8a6409.png";